import { render, staticRenderFns } from "./ScreenTools.vue?vue&type=template&id=1dee25fe&scoped=true"
import script from "./ScreenTools.vue?vue&type=script&lang=js"
export * from "./ScreenTools.vue?vue&type=script&lang=js"
import style0 from "./ScreenTools.vue?vue&type=style&index=0&id=1dee25fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dee25fe",
  null
  
)

export default component.exports